exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tips[data-v-20d48491] {\n  background-color: #3b3b62;\n  text-align: center;\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n.tips p[data-v-20d48491] {\n  padding: 5px 0;\n}\nh3[data-v-20d48491] {\n  margin-top: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20d48491","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/provider/tjkExamOperator.vue
// module id = 1205
// module chunks = 0